import { useModulesContext } from '../contexts';

/**
 * A custom hook that provides access to the navigation function from the ModulesContext.
 *
 * @important Prefer using `useNavigateToModule` instead of this hook.
 * This hook is only used for cases where the module is not known at the time of navigation.
 *
 * @returns {Function} The navigate function from the ModulesContext.
 * @throws {Error} If the navigate function is not configured in the RouterProvider.
 *
 * @example
 * const navigate = useNavigate();
 * navigate({ modulePathname: '/some-path', hasAccess: true });
 */
export default function useNavigate() {
  var context = useModulesContext();
  var navigate = context == null ? void 0 : context.navigate;
  if (!navigate) {
    throw new Error('"navigate" is missing');
  }
  return navigate;
}